import { inject } from "@angular/core";
import { AppInfoService } from "../services/app-info.service";
import { SharedDataService } from "app/services/sharedData.service";
import { UserService } from "./user.service";
import * as cookieUtils from '../utilities/cookie.utils';
import { Router } from "@angular/router";
import { PageConfig } from "config/page.config";
import { AuthService } from "app/services/auth.service";
import { map } from "rxjs";


export const nonAuthGuard = (route: any, state: any) => {

  const userService = inject(UserService);
  const appInfo = inject(AppInfoService);
  const sharedService = inject(SharedDataService);
  const authService = inject(AuthService);

  // console.log (`nonAuthGuard ${route}`)
  const cookieVal = cookieUtils.getCookie('PD-H-SESSION-ID');
  if (cookieVal && cookieVal.startsWith("1")) {
    console.log('Cookie PD-H-SESSION-ID exists!');
    if(typeof userService.profile === 'undefined'){
         return authService.getLoginUrl().pipe(
            map((response: any) => {
                window.location.assign(JSON.parse(response).url);
                return true;
            })
          );  
     }
  }else{
    console.log('Cookie PD-H-SESSION-ID does not exist!');
  }

  if (appInfo.token) {
    if(typeof userService.profile !== 'undefined'){
      // console.log (`nonAuthGuard before setting userInfo ${JSON.stringify(userService.profile)}`);
      sharedService.setUserInfo(userService.profile);
    }
    return true;
  } else {
    return true;
  }
};
